<template>
    <div>
        <v-card class="ma-2">
            <v-card-title  class="teal white--text">Divisi
                <v-spacer />
                <v-btn @click.stop="openForm(null)"><v-icon left>add</v-icon>Tambah</v-btn>
            </v-card-title>

            <v-card-title>
                <v-text-field v-model="table.search" prepend-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>

            <v-data-table class="elevation-1" :search="table.search" :headers="table.headers" :items="table.items" :items-per-page="10" :single-select="true" item-key="id" height="400"
            fixed-header>
                <template v-slot:item.kode="{ item }">
                    <v-chip color="green" dark>{{ item.kode }}</v-chip>
                </template>
                <template v-slot:item.parent="{ item }">
                    <v-chip v-if="item.parent !== ''" color="green" dark>{{ item.parent }}</v-chip>
                    <v-chip v-else color="green" dark>-</v-chip>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="blue" icon @click="openForm(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
                    <v-btn color="red" icon @click="deleteConfirmation(item)"> <v-icon>mdi-delete</v-icon> </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="form.isShowing" max-width="400px" persistent>
            <v-form ref="form" v-model="form.isValid" lazy-validation>
                <v-card>
                    <v-card-title>DIVISI</v-card-title>
                    <v-divider />
                    <v-container>
                        <v-select v-model="form.data.parent" label="Direktorat" :items="table.items" item-text="nama" item-value="kode"></v-select>
                        <v-text-field v-model="form.data.kode" label="Kode" :rules="[form.rules.required]"></v-text-field>
                        <v-text-field v-model="form.data.nama" label="Nama" :rules="[form.rules.required]"></v-text-field>
                        <v-text-field v-model="form.data.nick" label="Nick" :rules="[form.rules.required]"></v-text-field>
                    </v-container>
                    <v-card-actions>
                        <v-btn color="success" @click="submitForm()">Simpan</v-btn>
                        <v-btn color="orange" @click="closeForm()">Batal</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- DELETE ALERT -->
        <v-dialog v-model="form.isDeleting" max-width="400px" persistent>  
            <v-card>
                <v-card-title>HAPUS DATA</v-card-title>
                <v-divider />
                <v-container>
                    <v-row>
                        <v-col cols="3">Kode</v-col>
                        <v-col>{{form.data.kode}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">Nama</v-col>
                        <v-col>{{form.data.nama}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">Direktorat</v-col>
                        <v-col>{{form.data.parent}}</v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-btn color="success" @click="submitForm()">Hapus</v-btn>
                    <v-btn color="orange" @click="closeForm()">Batal</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>    
</template>



<script>

const API_URL = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;

import { rules as Rules } from "./../../lib/rules";


export default {
    data() {
        return {
            // Data table
            table: {
                search: "",
                headers: [
                    { text: "Kode", value: "kode", class: "green accent-2 subtitle-2" },
                    { text: "Nama", value: "nama", class: "green accent-2 subtitle-2" },
                    { text: "Direktorat", value: "parent", class: "green accent-2 subtitle-2" },
                    { text: "Nick", value: "nick", class: "green accent-2 subtitle-2" },
                    { text: "", value: "actions", sortable: false, class: "green accent-2 subtitle-2" }
                ],
                items: [],
            },

            // Form
            form: {
                data: {
                    id: null,
                    kode: "",
                    nama: "",
                    parent: "",
                    nick: "",
                },
                opened: false,
                isShowing: false,
                isEditing: false,
                isDeleting: false,
                isValid: false,
                rules: 
                {
                    required: Rules.required,
                }
            },

            submitting: false,

        }

    }, // data


    created() {
        axios.get(`${API_URL}/userman/divisi`)
        .then( (response) => {
            this.table.items = response.data;
        })
        .catch( (error) => {
            console.error(error);
        });

    }, // created


    methods: {
        resetForm() {
            console.log("Reset form");
            this.form.data = {
                id: null,
                kode: "",
                nama: "",
                parent: "",
                nick: "",
            };

            if (this.form.opened) this.$refs.form.reset();
        },

        closeForm() {
            console.log("Close form");
            this.resetForm();
            this.form.isShowing = false;
            this.form.isEditing = false;
            this.form.isDeleting = false;
        },

        openForm(item) {
            console.log("Open form");
            this.resetForm();

            if (item) {
                this.form.data.id = item.id;
                this.form.data.kode = item.kode;
                this.form.data.nama = item.nama;
                this.form.data.parent = item.parent;
                this.form.data.nick = item.nick;
                this.form.isEditing = true;
            }

            this.form.opened = true;
            this.form.isShowing = true;
        },

        deleteConfirmation(item) {
            console.log("Delete confirmation: ", item);

            if (item == null) return;

            this.form.data = item;
            this.form.isDeleting = true;
        },

        submitForm() {
            console.log("Submit form");
            
            if (!this.form.isDeleting && !this.$refs.form.validate()) return;

            const id = this.form.data.id;
            this.$store.dispatch("displayProgBar");

            // EDIT
            if (this.form.isEditing) {
                console.log("Edit: ", this.form.data);
                this.submitting = true;

                axios.put(`${API_URL}/userman/divisi/${id}`, this.form.data)
                .then( (response) => {
                    console.log("Response-Edit: ", response);

                    this.$store.dispatch('displayAlert', {
                        color: "success", 
                        message: `Data divisi berhasil diperbarui` 
                    });

                    const index = this.table.items.findIndex(element => { return element.id === id; });
                    if (index != -1) {
                        this.table.items.splice(index, 1, response.data);
                    }

                })
                .catch( (error) => {
                    console.error(error);

                    this.$store.dispatch('displayAlert', {
                        color: "error", 
                        message: `[${error.message}] Gagal update data divisi` 
                    });
                })
                .finally( () => {
                    this.$store.dispatch('closeProgBar');
                    this.submitting = false;
                });


            // DELETE
            } else if (this.form.isDeleting) {
                console.log("Delete: ", this.form.data);
                this.submitting = true;

                axios.delete(`${API_URL}/userman/divisi/${id}`)
                .then( (response) => {
                    console.log("Response-Delete: ", response);

                    this.$store.dispatch('displayAlert', {
                        color: "success", 
                        message: `Data divisi berhasil dihapus` 
                    });

                    const index = this.table.items.findIndex(element => { return element.id === id; });
                    if (index != -1) {
                        this.table.items.splice(index, 1);
                    }
                })
                .catch( (error) => {
                    console.error(error);

                    this.$store.dispatch('displayAlert', {
                        color: "error", 
                        message: `[${error.message}] Gagal menghapus data divisi` 
                    });
                })
                .finally( () => {
                    this.$store.dispatch('closeProgBar');
                    this.submitting = false;
                });

            // CREATE
            } else {
                console.log("Create: ", this.form.data);
                this.submitting = true;

                axios.post(`${API_URL}/userman/divisi`, this.form.data)
                .then( (response) => {
                    console.log("Response-Create: ", response);

                    this.$store.dispatch('displayAlert', {
                        color: "success", 
                        message: `Data divisi berhasil ditambahkan` 
                    });
                    
                    this.table.items.push(response.data);
                })
                .catch( (error) => {
                    console.error(error);

                    this.$store.dispatch('displayAlert', {
                        color: "error", 
                        message: `[${error.message}] Gagal menambahkan data divisi` 
                    });
                })
                .finally( () => {
                    this.$store.dispatch('closeProgBar');
                    this.submitting = false;
                });
            }

            this.closeForm();
        },


    }, // methods
}

</script>
